// src/components/privacy/Privacy.js
import React from "react";
import "./Privacy.css";

export default function Privacy() {
    return (
        <div className="privacy-container">
            <h1>Privacy Policy</h1>
            <p>Last updated: {new Date().toLocaleDateString("en-GB")}</p>

            <section>
                <h2>1. Information We Collect</h2>
                <p>
                    We collect only the information necessary to enable salon appointment
                    booking, such as your name, contact details, and booking preferences.
                </p>
            </section>

            <section>
                <h2>2. How We Use Your Information</h2>
                <p>
                    Your information is shared only with the salon you book an appointment
                    with. We do not sell, trade, or otherwise transfer your personal
                    information to outside parties.
                </p>
            </section>

            <section>
                <h2>3. Data Security</h2>
                <p>
                    We use reasonable measures to protect your personal information.
                    However, no system is completely secure, and we cannot guarantee
                    absolute protection.
                </p>
            </section>

            <section>
                <h2>4. Third-Party Services</h2>
                <p>
                    Salons listed on our platform are independent businesses. They may
                    have their own privacy practices, for which we are not responsible.
                </p>
            </section>

            <section>
                <h2>5. Your Consent</h2>
                <p>
                    By using our app, you consent to our Privacy Policy. If you do not
                    agree, please discontinue use of the application.
                </p>
            </section>

            <section>
                <h2>6. Changes to This Policy</h2>
                <p>
                    We may update this Privacy Policy periodically. Continued use of the
                    app after updates indicates acceptance of the changes.
                </p>
            </section>
        </div>
    );
}
